export const TEMPLATE_FIELD_KEYS = {
    FIELD_NAME: 'fieldName',
    SELECTED_TEMPLATE: 'selectedTemplate',
};
